import { AfterViewInit, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from './theme.service';
import { AlertController, PopoverController } from '@ionic/angular';
import { PopoverComponent } from './popover/popover.component';
import { PopoverAstroComponent } from './popoverastro/popover.component';
import { AstrologyAppService } from './services/astrology-app.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isAlertOpen = false;
  alertButtons = ['Action'];
  user: any;
  xyz: any;
  menuIsOpen = false;
  private readonly menuItemSelector = '#inbox-list ion-item[routerLink], #inbox-list ion-item[button], #inbox-list ion-toggle, #inbox-list ion-button';

  setOpen(isOpen: boolean) {
    this.isAlertOpen = isOpen;
  }
public themeColor = [
 { name: 'Default', class: 'default' },
 { name: 'Dark', class: 'dark-theme' },
 ]
  public appPages = [
    { title: 'Inbox', url: '/folder/Inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/Outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/Favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/Archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/Trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/Spam', icon: 'warning' },
  ];
  public selectTheme;
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  constructor(public astroAppService:AstrologyAppService , private alertController: AlertController,public router:Router,private theme: ThemeService,public popoverController: PopoverController) {
   this.selectTheme = 'default';
    this.dynamicTheme(this.selectTheme)
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.user = JSON.parse(currentUser);
    }
    
    this.astroAppService.authenticate_userastrologer().subscribe(
      data=>
      {
        /* console.log(data); */
        this.xyz =data;
        if(this.xyz.user)
        this.user = this.xyz.user;
      }
    ) 

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.updateMenuButtons(), 0);
      }
    });

  }

  ngAfterViewInit() {
    this.updateMenuButtons();
  }


  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Something Went Wrong',
      subHeader: 'API CALL ERROR',
      message: 'Error Fetching Data',
      buttons: ['Ok'],
    });

    await alert.present();
  }
  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true
    });
    return await popover.present();
  }

  async presentPopover1(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverAstroComponent,
      event: ev,
      translucent: true
    });
    return await popover.present();
  }

   dynamicTheme(st) {
    this.theme.activeTheme(st);
    /* console.log("hi",this.selectTheme,st) */

  }
  logout()
  {
    localStorage.clear();
  this.router.navigate(['/login'])
  }
  onClick(event){
    let systemDark = window.matchMedia("(prefers-color-scheme: dark)");
    systemDark.addListener(this.colorTest);
    if(event.detail.checked){
      document.body.setAttribute('data-theme', 'dark');
       this.theme.activeTheme('dark-theme');
    }
    else{
      document.body.setAttribute('data-theme', 'light');
      this.theme.activeTheme('default');
    }
    /* console.log(event); */
  }

   colorTest(systemInitiatedDark) {
    if (systemInitiatedDark.matches) {
      document.body.setAttribute('data-theme', 'dark');   
    } else {
      document.body.setAttribute('data-theme', 'light');
    }
  }

  private getMenuItems(): HTMLElement[] {
    return Array.from(document.querySelectorAll(this.menuItemSelector))
      .filter((item) => !item.hasAttribute('disabled')) as HTMLElement[];
  }

  private focusMenuItem(index: number) {
    const menuItems = this.getMenuItems();
    if (!menuItems.length) {
      return;
    }

    const safeIndex = Math.max(0, Math.min(index, menuItems.length - 1));
    setTimeout(() => menuItems[safeIndex].focus(), 0);
  }

  private updateMenuButtons() {
    const label = this.menuIsOpen ? 'Collapse navigation menu' : 'Expand navigation menu';
    const menuButtons = Array.from(document.querySelectorAll('ion-menu-button'));

    menuButtons.forEach((button) => {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      button.setAttribute('aria-expanded', String(this.menuIsOpen));
      button.setAttribute('aria-haspopup', 'menu');
      button.setAttribute('aria-controls', 'inbox-list');
    });
  }

  checkModuleAccess(...moduleNames: string[]): boolean {
    if (!this.user || !this.user.access) return false;

    return moduleNames.every((moduleName) =>
      this.user.access.some((module: any) => module.module === moduleName && module.isEnabled)
    );
  }

  onMenuOpen()
{
  this.menuIsOpen = true;
  this.updateMenuButtons();
  setTimeout(() => this.focusMenuItem(0), 150);
  /* console.log("hello"); */
    
  this.astroAppService.authenticate_userastrologer().subscribe(
    data=>
    {
      /* console.log(data); */
      this.xyz =data;
      if(this.xyz.user)
      this.user = this.xyz.user;
    }
  ) 
}

onMenuClose()
{
  this.menuIsOpen = false;
  this.updateMenuButtons();
}

onMenuKeydown(event: KeyboardEvent)
{
  const menuItems = this.getMenuItems();
  if (!menuItems.length) {
    return;
  }

  const activeIndex = menuItems.findIndex((item) => item === document.activeElement || item.contains(document.activeElement as Node));

  if (event.key === 'Tab' && activeIndex === -1) {
    this.focusMenuItem(0);
    return;
  }

  if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
    return;
  }

  event.preventDefault();
  const currentIndex = activeIndex === -1 ? 0 : activeIndex;
  const nextIndex = event.key === 'ArrowDown'
    ? Math.min(currentIndex + 1, menuItems.length - 1)
    : Math.max(currentIndex - 1, 0);

  this.focusMenuItem(nextIndex);
}

}
